import _ from 'lodash';

let productMetadata;

const meetsMinRequirement = (a, c, s, p) => {
    return a || c || s || p;
};

// 2021-02-24 - Debra Frum - US12408 - Experian - Address Standardization
// Moved check for country from the back-end to the front-end
const meetsAddressStandardizationReqs = (a, b, c, country) => {
    if (a && country.code === 'US') {
        return b || c;
    }
    return true;
};

// 2021-10-23 - Debra Frum - US13807 - PE - Claims- Address Validation Integration
const meetsCCAddressStandardizationReqs = (a, b, country) => {
    if (a && b && country.code === 'US') {
        return _.includes(['validated', 'overridden'], b.code);
    }
    return true;
};

const isStandardized = (mustStandardize, vCode) => {
    if (mustStandardize) {
        if (!vCode) {
            return false;
        }
        // US19812 replace deprecated contains with includes
        return _.includes(['validated', 'overridden'], vCode.code);
    }
    return true;
};

// DE8054 - disable the validation if typecode isn't configured
const isConfiguredCountryForState = (country) => {
    if (country) {
        const states = productMetadata.pc['typekey.State'].value;

        return _.some(states.codes, (code) => code.categories[0].typecode === country.code);
    }
    return false;
};

// 2020-10-08 - Debra Frum - US17553, DE10997 - Address Standardization
/*
 * Set status of standardization to indicate that the address has been Overridden
 * @param anAddress
 */
const setOverridden = (anAddress) => {
    anAddress.lastValidRqstTime_Ext = new Date();
    anAddress.lastValidationTime_Ext = null;
    anAddress.isValidated_Ext = false;
    anAddress.isNotValidated_Ext = false;
    anAddress.isOverridden_Ext = true;
    // 2022-05-02 - Debra Frum - DE13291 - Overridden Address in PC shown as not standardized / overridden in PE
    anAddress.isOverriddenInternally_Ext = false;

};

// 2021-02-24 - Debra Frum - US12408 - Experian - Address Standardization
/*
 * Set status of standardization to indicate that the address has not been Validated
 * @param anAddress
 */
const setNotValidated = (anAddress) => {
    anAddress.lastValidRqstTime_Ext = null;
    anAddress.lastValidationTime_Ext = null;
    anAddress.isValidated_Ext = false;
    anAddress.isNotValidated_Ext = true;
    anAddress.isOverridden_Ext = false;
    // 2022-05-02 - Debra Frum - DE13291 - Overridden Address in PC shown as not standardized / overridden in PE
    anAddress.isOverriddenInternally_Ext = false;
};

export default {
    'meetsMinRequirement': meetsMinRequirement,
    'meetsAddressStandardizationReqs': meetsAddressStandardizationReqs,
    'meetsCCAddressStandardizationReqs': meetsCCAddressStandardizationReqs,
    'isStandardized': isStandardized,
    'isConfiguredCountryForState': isConfiguredCountryForState,
    'setOverridden': setOverridden,
    'setNotValidated': setNotValidated,
    'setProductMetadata': (metadata) => {
        productMetadata = metadata;
    }
};
